import { render, staticRenderFns } from "./RecruiterDashBoard.vue?vue&type=template&id=9fd2f26e&scoped=true"
import script from "./RecruiterDashBoard.vue?vue&type=script&lang=js"
export * from "./RecruiterDashBoard.vue?vue&type=script&lang=js"
import style0 from "./RecruiterDashBoard.vue?vue&type=style&index=0&id=9fd2f26e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9fd2f26e",
  null
  
)

export default component.exports